<svg
  width="20"
  height="20"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM6.96578 5.83441C6.65336 5.52199 6.14683 5.52199 5.83441 5.83441C5.52199 6.14683 5.52199 6.65336 5.83441 6.96578L6.86873 8.0001L5.83441 9.03441C5.52199 9.34683 5.52199 9.85336 5.83441 10.1658C6.14683 10.4782 6.65336 10.4782 6.96578 10.1658L8.0001 9.13147L9.03441 10.1658C9.34683 10.4782 9.85336 10.4782 10.1658 10.1658C10.4782 9.85336 10.4782 9.34683 10.1658 9.03441L9.13147 8.0001L10.1658 6.96578C10.4782 6.65336 10.4782 6.14683 10.1658 5.83441C9.85336 5.52199 9.34683 5.52199 9.03441 5.83441L8.0001 6.86873L6.96578 5.83441Z"
    style="fill: #535862 !important;"
  />
</svg>
